import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { FaPlus, FaFile, FaTimes, FaDownload, FaTrash, FaPaperclip } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { listarDepartamentos, buscarAssuntosFaq, criarConteudoFaq, editarConteudoFaq, uploadAnexoFaq, buscarAnexosFaq, downloadAnexoFaq, excluirAnexoFaq } from '~/Services/Service';
import ModalCadastroAssunto from './ModalCadastroAssunto';
import ModalConfirmacao from '~/Components/ModalConfirmacao';

const ModalInclusao = ({ show, onHide, conteudoEdicao, onSave, departamentoUsuario }) => {
  var modoEdicao = !!conteudoEdicao;
  const [departamentoOptions, setDepartamentoOptions] = useState([]);
  const [assuntoOptions, setAssuntoOptions] = useState([]);
  const [departamento, setDepartamento] = useState(null);
  const [assunto, setAssunto] = useState(null);
  const [titulo, setTitulo] = useState('');
  const [conteudo, setConteudo] = useState('');
  const [arquivosSelecionados, setArquivosSelecionados] = useState([]);
  var fileInputRef = React.useRef(null);
  const [showModalAssunto, setShowModalAssunto] = useState(false);
  const [errors, setErrors] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [anexosExistentes, setAnexosExistentes] = useState([]);
  const [carregandoAnexos, setCarregandoAnexos] = useState(false);
  const [anexoParaExcluir, setAnexoParaExcluir] = useState(null);
  const [excluindoAnexo, setExcluindoAnexo] = useState(false);

  useEffect(function() {
    listarDepartamentos().then(function(res) {
      var deptos = res || [];
      var opcoes = deptos.map(function(d) {
        return { value: d.codigo, label: d.descricao };
      });
      setDepartamentoOptions(opcoes);

      if (!conteudoEdicao && departamentoUsuario) {
        var deptoUsuario = opcoes.find(function(d) { return d.value === departamentoUsuario; });
        if (deptoUsuario) setDepartamento(deptoUsuario);
      }
    }).catch(function() { /* ignore */ });
  }, [show]);

  var carregandoEdicao = React.useRef(false);

  useEffect(function() {
    if (!show || !conteudoEdicao) return;
    carregandoEdicao.current = true;
    setTitulo(conteudoEdicao.titulo || '');
    var textoEdicao = conteudoEdicao.texto || '';
    setConteudo(textoEdicao.replace(/<br\s*\/?>/g, '\n'));
    setDepartamento({ value: conteudoEdicao.codigo_departamento, label: conteudoEdicao.nome_departamento });
    buscarAssuntosFaq(conteudoEdicao.codigo_departamento)
      .then(function(res) {
        var assuntos = res || [];
        setAssuntoOptions(
          assuntos.map(function(a) {
            return { value: a.codigo, label: a.nome };
          })
        );
        setAssunto({ value: conteudoEdicao.codigo_faq_assunto, label: conteudoEdicao.nome_assunto });
      })
      .catch(function() {
        setAssuntoOptions([]);
        setAssunto({ value: conteudoEdicao.codigo_faq_assunto, label: conteudoEdicao.nome_assunto });
      })
      .finally(function() {
        carregandoEdicao.current = false;
      });

    setCarregandoAnexos(true);
    buscarAnexosFaq(conteudoEdicao.codigo)
      .then(function(res) {
        setAnexosExistentes(res || []);
      })
      .catch(function() {
        setAnexosExistentes([]);
      })
      .finally(function() {
        setCarregandoAnexos(false);
      });
  }, [show, conteudoEdicao]);

  var carregarAssuntos = function(codigoDepartamento) {
    buscarAssuntosFaq(codigoDepartamento).then(function(res) {
      var assuntos = res || [];
      setAssuntoOptions(
        assuntos.map(function(a) {
          return { value: a.codigo, label: a.nome };
        })
      );
    }).catch(function() {
      setAssuntoOptions([]);
    });
  };

  useEffect(function() {
    if (carregandoEdicao.current) return;
    if (!departamento) {
      setAssuntoOptions([]);
      setAssunto(null);
      return;
    }
    carregarAssuntos(departamento.value);
    setAssunto(null);
  }, [departamento]);

  const validar = () => {
    var errs = {};
    if (!departamento) errs.departamento = 'Departamento é obrigatório';
    if (!assunto) errs.assunto = 'Assunto é obrigatório';
    if (!titulo.trim()) errs.titulo = 'Título é obrigatório';
    if (!conteudo.trim()) errs.conteudo = 'Conteúdo é obrigatório';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSalvar = () => {
    if (!validar()) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }
    setSalvando(true);
    var dados = {
      codigo_faq_assunto: assunto.value,
      titulo: titulo.trim(),
      texto: conteudo.trim().replace(/\n/g, '<br>'),
    };

    if (modoEdicao) {
      editarConteudoFaq(conteudoEdicao.codigo, dados)
        .then(function() {
          if (arquivosSelecionados.length > 0) {
            var uploads = arquivosSelecionados.reduce(function(promise, arquivo) {
              return promise.then(function() {
                var formData = new FormData();
                formData.append('file', arquivo);
                return uploadAnexoFaq(conteudoEdicao.codigo, formData).catch(function() {
                  toast.warning('Erro ao enviar arquivo: ' + arquivo.name);
                });
              });
            }, Promise.resolve());
            return uploads;
          }
        })
        .then(function() {
          toast.success('Tópico atualizado com sucesso!');
          if (onSave) onSave();
          handleClose();
        })
        .catch(function(err) {
          var msg = err && err.response && err.response.data && err.response.data.mensagem
            ? err.response.data.mensagem
            : 'Erro ao atualizar Tópico. Tente novamente.';
          toast.error(msg);
        })
        .finally(function() {
          setSalvando(false);
        });
    } else {
      criarConteudoFaq(dados)
        .then(function(res) {
          var codigoConteudo = res && res.codigo;
          if (arquivosSelecionados.length > 0 && codigoConteudo) {
            var uploads = arquivosSelecionados.reduce(function(promise, arquivo) {
              return promise.then(function() {
                var formData = new FormData();
                formData.append('file', arquivo);
                return uploadAnexoFaq(codigoConteudo, formData).catch(function() {
                  toast.warning('Erro ao enviar arquivo: ' + arquivo.name);
                });
              });
            }, Promise.resolve());
            return uploads;
          }
        })
        .then(function() {
          toast.success('Tópico cadastrado com sucesso!');
          if (onSave) onSave();
          handleClose();
        })
        .catch(function(err) {
          var msg = err && err.response && err.response.data && err.response.data.mensagem
            ? err.response.data.mensagem
            : 'Erro ao cadastrar Tópico. Tente novamente.';
          toast.error(msg);
        })
        .finally(function() {
          setSalvando(false);
        });
    }
  };

  const onFileChange = (e) => {
    var novosArquivos = Array.from(e.target.files);
    setArquivosSelecionados(function(prev) { return prev.concat(novosArquivos); });
    e.target.value = '';
  };

  const onRemoverArquivoSelecionado = (index) => {
    setArquivosSelecionados(function(prev) { return prev.filter(function(_, i) { return i !== index; }); });
  };

  var handleDownloadAnexo = function(anexo) {
    downloadAnexoFaq(anexo.codigo, anexo.nome_arquivo).catch(function() {
      toast.error('Erro ao baixar anexo: ' + anexo.nome_arquivo);
    });
  };

  var handleConfirmarExclusao = function(confirmou) {
    if (!confirmou) {
      setAnexoParaExcluir(null);
      return;
    }
    var anexo = anexoParaExcluir;
    setExcluindoAnexo(true);
    excluirAnexoFaq(anexo.codigo)
      .then(function() {
        setAnexosExistentes(function(prev) {
          return prev.filter(function(a) { return a.codigo !== anexo.codigo; });
        });
        toast.success('Anexo excluído com sucesso!');
      })
      .catch(function() {
        toast.error('Erro ao excluir anexo. Tente novamente.');
      })
      .finally(function() {
        setExcluindoAnexo(false);
        setAnexoParaExcluir(null);
      });
  };

  const handleLimpar = () => {
    setDepartamento(null);
    setAssunto(null);
    setTitulo('');
    setConteudo('');
    setArquivosSelecionados([]);
    setErrors({});
    setAnexosExistentes([]);
    setCarregandoAnexos(false);
    setAnexoParaExcluir(null);
    setExcluindoAnexo(false);
  };

  const handleClose = () => {
    handleLimpar();
    onHide();
  };

  return (
    <>
    <Modal show={show} onHide={handleClose} size="lg" centered>
      {showModalAssunto && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
          borderRadius: '.3rem',
        }} />
      )}
      <Modal.Header closeButton>
        <Modal.Title>{modoEdicao ? 'Editar Tópico' : 'Nova Inclusão'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="align-items-end mb-3">
            <Col xs={12} sm={6} className="mb-3 mb-sm-0">
              <Form.Group className="mb-0">
                <Form.Label>Departamento <span className="text-danger">*</span></Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={departamentoOptions}
                  value={departamento}
                  onChange={(val) => { setDepartamento(val); setErrors(function(prev) { var e = Object.assign({}, prev); delete e.departamento; return e; }); }}
                  styles={errors.departamento ? { ...customStyles, control: function(base) { return Object.assign({}, base, { padding: '2px', borderRadius: '6px', borderColor: '#dc3545' }); } } : customStyles}
                  components={{ DropdownIndicator }}
                  noOptionsMessage={() => 'Nenhuma opção'}
                  isDisabled={!!departamentoUsuario}
                  isClearable={false}
                />
                {errors.departamento && <small className="text-danger">{errors.departamento}</small>}
              </Form.Group>
            </Col>
            <Col xs={10} sm className="mb-3 mb-sm-0">
              <Form.Group className="mb-0">
                <Form.Label>Assunto <span className="text-danger">*</span></Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={assuntoOptions}
                  value={assunto}
                  onChange={(val) => { setAssunto(val); setErrors(function(prev) { var e = Object.assign({}, prev); delete e.assunto; return e; }); }}
                  styles={errors.assunto ? { ...customStyles, control: function(base) { return Object.assign({}, base, { padding: '2px', borderRadius: '6px', borderColor: '#dc3545' }); } } : customStyles}
                  components={{ DropdownIndicator }}
                  noOptionsMessage={() => 'Nenhuma opção'}
                  isClearable
                />
                {errors.assunto && <small className="text-danger">{errors.assunto}</small>}
              </Form.Group>
            </Col>
            <Col xs="auto">
              <Button variant="outline-primary" title="Adicionar novo assunto" style={{ height: 42, width: 42 }} onClick={() => setShowModalAssunto(true)}>
                <FaPlus />
              </Button>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Título <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Digite o título"
              value={titulo}
              onChange={(e) => { setTitulo(e.target.value); setErrors(function(prev) { var er = Object.assign({}, prev); delete er.titulo; return er; }); }}
              isInvalid={!!errors.titulo}
            />
            {errors.titulo && <small className="text-danger">{errors.titulo}</small>}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Conteúdo <span className="text-danger">*</span></Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Digite o conteúdo..."
              value={conteudo}
              onChange={(e) => { setConteudo(e.target.value); setErrors(function(prev) { var er = Object.assign({}, prev); delete er.conteudo; return er; }); }}
              isInvalid={!!errors.conteudo}
            />
            {errors.conteudo && <small className="text-danger">{errors.conteudo}</small>}
          </Form.Group>

          {modoEdicao && (
            <Form.Group className="mb-3">
              <Form.Label><FaPaperclip className="mr-1" />Anexos registrados</Form.Label>
              {carregandoAnexos ? (
                <div className="mt-1">
                  <Spinner animation="border" size="sm" /> <small>Carregando anexos...</small>
                </div>
              ) : anexosExistentes.length > 0 ? (
                <div>
                  {anexosExistentes.map(function(anexo) {
                    return (
                      <div key={anexo.codigo} className="d-flex align-items-center rounded p-2 mb-1 bg-light">
                        <FaFile className="text-secondary mr-2" />
                        <span className="flex-grow-1 small">{anexo.nome_arquivo}</span>
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 text-primary mr-2"
                          onClick={function() { handleDownloadAnexo(anexo); }}
                          title="Baixar anexo"
                        >
                          <FaDownload />
                        </Button>
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 text-danger"
                          onClick={function() { setAnexoParaExcluir(anexo); }}
                          disabled={excluindoAnexo}
                          title="Excluir anexo"
                        >
                          <FaTrash />
                        </Button>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-muted small mb-0 mt-1">Nenhum anexo registrado</p>
              )}
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label>{modoEdicao ? 'Adicionar novos anexos' : 'Anexos'}</Form.Label>
            <div>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={onFileChange}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.zip,.rar"
                style={{ display: 'none' }}
              />
              <Button variant="outline-secondary" size="sm" onClick={function() { fileInputRef.current.click(); }}>
                Escolher Arquivos
              </Button>
            </div>
            <Form.Text className="text-muted">
              Formatos aceitos: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, ZIP, RAR
            </Form.Text>

            {arquivosSelecionados.length > 0 && (
              <div className="mt-2">
                <small className="text-muted d-block mb-1">Arquivos selecionados:</small>
                {arquivosSelecionados.map(function(arquivo, index) {
                  return (
                    <div key={index} className="d-flex align-items-center rounded p-2 mb-1" style={{ backgroundColor: '#e7f3ff' }}>
                      <FaFile className="text-primary mr-2" />
                      <span className="flex-grow-1 small">{arquivo.name}</span>
                      <small className="text-muted mr-2">({(arquivo.size / 1024).toFixed(1)} KB)</small>
                      <Button variant="link" size="sm" className="p-0 text-danger" onClick={function() { onRemoverArquivoSelecionado(index); }} title="Remover">
                        <FaTimes />
                      </Button>
                    </div>
                  );
                })}
              </div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {!modoEdicao && (
          <Button variant="outline-danger" onClick={handleLimpar} className="mr-2" disabled={salvando}>
            Limpar
          </Button>
        )}
        <Button variant="primary" onClick={handleSalvar} disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>

      <ModalCadastroAssunto
        show={showModalAssunto}
        onHide={() => setShowModalAssunto(false)}
        onSucesso={function() {
          if (departamento) {
            carregarAssuntos(departamento.value);
          }
        }}
        departamentoUsuario={departamentoUsuario}
      />

      <ModalConfirmacao
        show={!!anexoParaExcluir}
        onClose={handleConfirmarExclusao}
        title="Excluir anexo"
        message={anexoParaExcluir ? 'Deseja realmente excluir o anexo "' + anexoParaExcluir.nome_arquivo + '"?' : ''}
      />
    </>
  );
};

export default ModalInclusao;
